/**
 * `/help` (plan 13 §6): only commands that work, each with the syntax it
 * accepts. A line is shown when the player's GM level may run its command.
 * When you add, remove or change a chat command, change its line here.
 */
import { canExecuteCommand } from '../../shared/constants/GMPermissions';

/** [command whose permission gates the line, the line]. */
export const HELP_LINES: ReadonlyArray<readonly [string, string]> = [
  ['help', '/help - Show this list'],
  ['jobs', '/jobs - Open the jobs window'],
  ['duel', '/duel <name> - Challenge a player; /duel accept to accept'],
  ['eventlist', '/eventlist, /eventjoin, /eventleave - GM events'],
  ['sim', '/sim - Run a bot tournament'],
  ['stats', '/stats - Your stats in chat'],
  ['datastate', '/datastate - Your id, position and level'],
  ['debugmap', '/debugmap - Current map state'],
  ['maps', '/maps - List maps'],
  ['mapinfo', '/mapinfo <mapId> - Details of a map'],
  ['platforms', '/platforms - Current platform bounds'],
  ['renderstate', '/renderstate - Camera and display info'],
  ['kernel-systems', '/kernel-systems - Registered game systems'],
  ['announce', '/announce <message> - Broadcast an announcement'],
  ['tp', '/tp <x> <y> - Teleport (a comma works too: /tp x,y)'],
  ['heal', '/heal [amount] - Heal'],
  ['mana', '/mana [amount|infinite] - Restore or toggle infinite mana'],
  ['damage', '/damage <amount> - Hurt yourself'],
  ['kill', '/kill - Die'],
  ['xp', '/xp <amount> - Add XP'],
  ['gold', '/gold <amount> - Add gold'],
  ['level', '/level <n> - Set level'],
  ['levelup', '/levelup - Gain a level'],
  ['god', '/god (or /invincible) - Toggle god mode'],
  ['speed', '/speed <multiplier> - Movement speed, e.g. /speed 1.5'],
  ['tracker', '/tracker - Projectile tracker window'],
  ['killnpc', '/killnpc <all|nearest|id|type> - Defeat mobs'],
  ['spawn', '/spawnmob <type> [x] [y] - Spawn a mob (/spawn is the same)'],
  ['killall', '/killall (or /clear) - Defeat every mob (memory-mode server)'],
  ['noclip', '/noclip - Toggle noclip'],
  ['class', '/class <name> - Change class'],
  ['load', '/load <mapId> (or /map) - Load a map'],
  ['reloadmap', '/reloadmap - Reload the current map'],
  ['gcd', '/gcd <ms> - Override the global cooldown (0 = none)'],
  ['bot', '/bot spawn <class> [n] | despawn [all] | list - Bots'],
  ['loadzone', '/loadzone <zoneId> - Load a zone\'s spawns'],
  ['spawn_test', '/spawn_test [index] - Spawn a test player'],
  ['pvp', '/pvp [status|reset] - Room PvP settings'],
  ['setgm', '/setgm <name> <0-5> - Set a player\'s GM level'],
];

export function helpLines(gmLevel: number): string[] {
  return HELP_LINES.filter(([command]) => canExecuteCommand(gmLevel, command)).map(([, line]) => line);
}
